import AddButton from '@portal/features/navigation/AddButton'
import BackButton from '@portal/features/navigation/BackButton'
import { Header } from '@portal/features/navigation/Header'
import SubmissionList from '@portal/features/submissions/SubmissionList'
import { SurveyTitle } from '@portal/features/titles'
import TopicDrawer from '@portal/features/topics/TopicDrawer'
import { createFileRoute, useParams } from '@tanstack/react-router'
import { useState } from 'react'

const RouteComponent = () => {
  const { surveyId } = useParams({ strict: false })
  const [isDrawerOpen, setIsDrawerOpen] = useState(false)

  return (
    <>
      <Header.Left>
        <BackButton to="/dashboard" />
      </Header.Left>
      <Header.Center>
        <SurveyTitle />
      </Header.Center>
      <Header.Right>
        <AddButton onPress={() => setIsDrawerOpen(true)} />
      </Header.Right>
      <SubmissionList onAdd={() => setIsDrawerOpen(true)} />
      <TopicDrawer
        surveyId={surveyId!}
        isOpen={isDrawerOpen}
        onOpenChange={setIsDrawerOpen}
      />
    </>
  )
}

export const Route = createFileRoute('/_app/surveys/$surveyId/submissions')({
  component: RouteComponent,
})
